var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSection)?_c('div',{staticClass:"section-comments"},[_vm._m(0),_vm._l((_vm.sectionData.comments),function(comment,index){return _c('com-comment',{key:index,attrs:{"comment":comment}})})],2):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('p',{staticClass:"nav-title"},[_vm._v("评论区")])])
}]

export { render, staticRenderFns }